/**
 * The in-flight indicator shared by every control that takes a `pending` state. `currentColor`
 * throughout, so it tints itself from the label and needs no per-variant treatment. Reduced motion
 * gets a pulse rather than a frozen ring, which would signal nothing.
 */
export function PendingSpinner() {
  return (
    <span
      aria-hidden="true"
      className="size-3.5 shrink-0 animate-spin rounded-full border-2 border-[color-mix(in_oklab,currentColor_30%,transparent)] border-t-current [animation-duration:0.7s] motion-reduce:animate-pulse"
    />
  )
}
